import {
  hotspotIcon,
  generateCustomIconXml
} from '~js/helpers'

const getMarkerTeleportXml = function (marker, ath, atv, useCustomIcon, index, markerScale) {
  const teleportPanoramaIndexFromOne = marker.teleportPanoramaIndex + 1 || 1
  const opacity = marker.opacity ? (marker.opacity / 100) : 0.6
  if (marker.customCoordinate && marker.coordinatePlane !== 0 && marker.rotation) {
    const inverserotation = (marker.coordinatePlane === 3)
    const rx = marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    const ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    const rz = marker.rotation.z
    return `<hotspot
    name="markerInfo_${marker.objectId}"
    style="markerInfo"
    scale="0"
    visible="false"
    ath="${ath}"
    atv="${atv - 6}"
    alpha="${opacity}"
    enabled="false"
    zorder="${marker.index}" />
      <hotspot
    name="marker_${marker.objectId}"
    style="${hotspotIcon(marker, useCustomIcon)}"
    scale="${markerScale}"
    ath="${ath}"
    atv="${atv}"
    alpha="${opacity}"
    zorder="${marker.index}"
    distorted="true"
    inverserotation="${inverserotation}"
    rx="${rx}"
    ry="${ry}"
    rz="${rz}"
    mipmapping="true"
    enabled="${!marker.disabled}"
    capture="false"
    ${generateCustomIconXml(marker)}
    onclick="on_teleport_click(${index});change_building(${marker.nextBuildingId}, ${teleportPanoramaIndexFromOne || 1}, ${marker.objectId});"
    onover="marker_mousein(${marker.objectId}, ${index}, 'teleport');"
    onout="marker_mouseout(${marker.objectId}, ${index}, 'teleport', ${opacity});" />`
  }
  return `<hotspot
  name="markerInfo_${marker.objectId}"
  style="markerInfo"
  scale="0"
  visible="false"
  ath="${ath}"
  atv="${atv - 6}"
  alpha="${opacity}"
  enabled="false"
  zorder="${marker.index}" />
    <hotspot
  name="marker_${marker.objectId}"
  style="${hotspotIcon(marker, useCustomIcon)}"
  scale="${markerScale}"
  ath="${ath}"
  atv="${atv}"
  alpha="${opacity}"
  zorder="${marker.index}"
  enabled="${!marker.disabled}"
  capture="false"
  ${generateCustomIconXml(marker)}
  onclick="on_teleport_click(${index});change_building(${marker.nextBuildingId}, ${teleportPanoramaIndexFromOne || 1}, ${marker.objectId});"
  onover="marker_mousein(${marker.objectId}, ${index}, 'teleport');"
  onout="marker_mouseout(${marker.objectId}, ${index}, 'teleport', ${opacity});" />`
}

export default getMarkerTeleportXml
